import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import logo from "../../assets/GeneraliSeguros__BLUE_RGB.png";
import "./navbarUi.css";
import {   NavLink } from 'react-router-dom';
import LanguageSelector from './languageSelector'

function NavbarUI({ apps }) {
  

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  return (
    <>
      <Navbar  className="navbar__contenedor">
        <Navbar.Brand className="navbar__contenido">
          <img
            alt="logo"
            src={logo}
            className="d-inline-block align-top logo-navbar"
          />
          <Nav className="mr-auto">
            {apps.filter(onlyUnique).map((app) => (
                <NavLink activeClassName="activo" to={`/${app}`} className='seccion'  key={app}>
                {app}
                </NavLink>
            ))}
          </Nav>
          Generali Data Archival
          <LanguageSelector />
        </Navbar.Brand>
      </Navbar>
    </>
  );
}

export default NavbarUI;
